/**
 * Delete every Advisor run for one client (`advisor.client.delete`, an Admin's): the name is typed, matched without
 * regard to case or spacing, and the runs go with their file links and matching records.
 */

import { useState } from 'react';

import { ClientIn, clientInClientMax } from '@/api/generated/schemas';
import { useDeleteClientRuns } from '@/api/queries';
import { fieldErrors } from '@/api/validate';
import { ConfirmDialog } from '@/ui/ConfirmDialog';

export function DeleteClientDialog({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState('');
  const remove = useDeleteClientRuns();
  const ready = Object.keys(fieldErrors(ClientIn, { client: name })).length === 0;
  return (
    <ConfirmDialog
      title="Delete a client's runs"
      confirmLabel="Delete runs"
      danger
      pending={remove.isPending}
      error={remove.error}
      onClose={onClose}
      onConfirm={() => {
        if (ready) remove.mutate(name.trim(), { onSuccess: onClose });
      }}
    >
      <p>
        Every Advisor run for this client is deleted for everyone, with the files they read and their matching records.
        This cannot be undone.
      </p>
      <div className="field">
        <label htmlFor="delete-client-name">Client name</label>
        <input
          id="delete-client-name"
          type="text"
          required
          autoFocus
          maxLength={clientInClientMax}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
    </ConfirmDialog>
  );
}
